import { render, staticRenderFns } from "./RegistracijaSudionika.vue?vue&type=template&id=013011ae&scoped=true&"
import script from "./RegistracijaSudionika.vue?vue&type=script&lang=js&"
export * from "./RegistracijaSudionika.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013011ae",
  null
  
)

export default component.exports